<!-- Dale this testingchase div use I didnot understand so inside I simply chged with paymentus token and updatePaymentusIframe 
if not required i will remove it -->
<div *ngIf="TESTINGCHASE" fxLayout="row" fxLayoutGap="16px" style="padding-bottom: 20px">
  <div fxFlex="30%">
    <apt-input label="Paymentus token: DO NOT USE IN PROD" style="width: 100%">
      <input type="text" placeholder="PamentUs Token " [(ngModel)]="paymentUsToken" />
    </apt-input>
  </div>
  <div fxFlex fxLayout="column" fxLayoutAlign="end start">
    <apt-button tertiary (click)="updatePaymentUsIframe(paymentUsToken)">Load UID in Iframe</apt-button>
  </div>
</div>

<ng-container
  *ngIf="BYPASSBINDCALL || policyStore?.policyData?.policy.quoteStatus === 'BND' || paymentUsToken || TESTINGCHASE"
>
  <!-- <app-quote-header
    [insuredName]="policyStore?.policyData?.policy.addressDto.insuredName"
    [address]="addressString"
    [policyType]="coverageLiteralName"
    [issuingCompany]="policyStore?.policyData?.policy.issuingCompany"
  >
  </app-quote-header> -->

  <dtc-page-content>
    <ng-container main>
      <dtc-bread-crumbs></dtc-bread-crumbs>

      <apt-h1 class="underline-title">
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex class="theme-title" [style.color]="theme?.primaryColor">Payment</div>
        </div>
      </apt-h1>

      <ng-container *ngIf="iframeSrc">
        <apt-h2>Payment Information</apt-h2>
        <ng-container *ngIf="showSavedPaymentOption">
          <div style="margin-bottom: 12px">
            <apt-checkbox [label]="savedPaymentLabel">
              <input type="checkbox" name="useSavedPaymentMethodConsumer" [(ngModel)]="useSavedPaymentMethod" />
            </apt-checkbox>
          </div>

          <div *ngIf="useSavedPaymentMethod" style="margin-bottom: 20px">
            <apt-button-footer>
              <ng-container buttonFooterLeft>
                <dtc-button fxHide.lt-sm secondary large type="button" (click)="goToPolicy()">Cancel</dtc-button>
              </ng-container>

              <ng-container buttonFooterRight>
                <dtc-button
                  fxHide.lt-sm
                  fxFlex.lt-sm="100"
                  [primary]="true"
                  type="button"
                  (click)="payWithSavedPaymentMethod()"
                  [disabled]="processingPayment"
                >
                  Pay
                </dtc-button>
              </ng-container>
            </apt-button-footer>

            <div fxHide.gt-xs fxLayout.lt-sm="column" fxLayout.gt-xs="row">
              <dtc-button
                fxFlex.lt-sm="100"
                [primary]="true"
                type="button"
                (click)="payWithSavedPaymentMethod()"
                [disabled]="processingPayment"
              >
                Pay
              </dtc-button>

              <dtc-button
                fxFlex
                fxHide.gt-xs
                secondary
                type="button"
                (click)="goToPolicy()"
                [ngStyle]="{ 'margin-top': '20px' }"
              >
                Cancel
              </dtc-button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="showPaymentIframe">
          <apt-iframe
            [src]="iframeSrc"
            class="payment-iframe"
            class.lt-md="mobile-payment"
            [sandbox]="true"
          ></apt-iframe>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container right>
      <payment-summary [editable]="false" [policyStore]="policyStore" [product]="policyStore.product">
      </payment-summary>

      <div *ngIf="show_paymentusFormOnly" style="margin-top: 20px">
        <apt-checkbox label="No Post Payment Processing">
          <input type="checkbox" name="paymentusFormOnly" required [(ngModel)]="show_paymentusFormOnly" />
        </apt-checkbox>
      </div>

      <div *ngIf="show_paymentusFormOnly && displayToken" style="margin-top: 10px">
        Paymentus Token: {{ displayToken }}
      </div>

      <ng-container *ngIf="errors && errors.length">
        <div style="margin-top: 16px">
          <apt-h2 underline>Errors</apt-h2>
        </div>
        <!-- <apt-inform state="error">{{errors.join(',')}}</apt-inform> -->
        <apt-inform *ngFor="let error of errors" state="error">{{ error.message }}</apt-inform>
      </ng-container>

      <contact-box
        [overrideTheme]="d2cTheme"
        [phoneType]="'phoneD2C'"
        [producerId]="policyStore?.policyData?.policy?.agentCd"
      ></contact-box>
    </ng-container>
  </dtc-page-content>

  <apt-dialog title="" modal="true" [(open)]="processingPayment" width="670px" [showCloseX]="false">
    <ng-container dialogBody>
      <apt-waiter
        [evaluate]="!processingPayment"
        [title]="'Processing Payment'"
        [rollingText]="processPayMessages"
        [rollingWait]="4000"
        [repeat]="false"
        [timeout]="0"
        [(timedOut)]="processPayTimedOut"
        (timedOutChange)="processPayTimeOutChange($event)"
        [contactInfo]="contactInfo"
      ></apt-waiter>
    </ng-container>
  </apt-dialog>

  <apt-dialog title="" modal="true" [(open)]="loadingSavedPaymentProfile" width="670px" [showCloseX]="false">
    <ng-container dialogBody>
      <apt-waiter
        [evaluate]="!loadingSavedPaymentProfile"
        [title]="'Loading Payment Information'"
        [rollingText]="savedPaymentLookupMessages"
        [rollingWait]="2000"
        [repeat]="true"
        [timeout]="0"
      ></apt-waiter>
    </ng-container>
  </apt-dialog>
</ng-container>

<ng-container *ngIf="!BYPASSBINDCALL && policyStore?.policyData?.policy.quoteStatus === 'QTD'">
  <apt-template-nested-state state="info" title="POLICY NOT BOUND">
    <ng-container message>
      <p>This policy must be in "BIND" status before you can pay.</p>
      <apt-button [primary]="true" (click)="goToPolicy()">Go to Policy Page</apt-button>
    </ng-container>
  </apt-template-nested-state>
</ng-container>

<ng-container
  *ngIf="policyStore?.policyData?.policy.quoteStatus !== 'QTD' && policyStore?.policyData?.policy.quoteStatus !== 'BND'"
>
  <apt-template-nested-state state="info" title="INVALID POLICY">
    <ng-container message>
      <p>This policy cannot proceed to payment. It has either been issued or is not valid.</p>
    </ng-container>
  </apt-template-nested-state>
</ng-container>
